import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

export const ShoppersTableHead = (props) => {
  const { t } = useTranslation();

  const { classes, order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = [
    {
      id: 'id',
      label: t('Shoppers.table.id'),
      align: 'left',
    },
    { id: 'firstname', label: t('Shoppers.table.firstName'), align: 'left' },
    { id: 'lastname', label: t('Shoppers.table.lastName'), align: 'left' },
    {
      id: 'email',
      label: t('Shoppers.table.email'),
      align: 'left',
    },
    {
      id: 'active',
      label: t('Shoppers.table.active'),
      align: 'left',
    },
    {
      id: 'jobassignment',
      label: t('Shoppers.table.jobAssignment'),
      align: 'left',
    },
    {
      id: 'edit',
      label: '',
      align: 'left',
    },
    {
      id: 'delete',
      label: '',
      align: 'left',
    },
  ];

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align}
            padding="center"
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              disabled={true}>
              <strong>{headCell.label}</strong>
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

ShoppersTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
